import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useGetLiveStatusQuery } from '../../apps/professional-app/fa/store/fa'
import { selectHasLiveMeetings, selectLiveMeetingsPollingEnabled, setHasLiveMeeting } from '../../store/liveMeetings/liveMeetings'
import classNames from 'classnames'
import './LiveIcon.scss'

export const LiveIcon: React.FC = () => {
  const dispatch = useAppDispatch()
  const accountId = useAppSelector(selectAccountId)
  const hasLiveSession = useAppSelector(selectHasLiveMeetings)
  const roomSessionsPollingEnabled = useAppSelector(selectLiveMeetingsPollingEnabled)

  const { data: liveStatus } = useGetLiveStatusQuery(
    { accountId },
    { refetchOnMountOrArgChange: true, pollingInterval: 30000, skipPollingIfUnfocused: true, skip: roomSessionsPollingEnabled },
  )

  useEffect(() => {
    if (!liveStatus?.data) {
      return
    }
    dispatch(setHasLiveMeeting(liveStatus.data.hasLiveSession))
  }, [dispatch, liveStatus])

  return (
    <div className={classNames({ 'live-icon-container': hasLiveSession })}>
      <i className='bi bi-broadcast' />
    </div>
  )
}
